import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import pick from 'lodash/pick'
import Connection from '../../../stores/connection.js'
import keyBy from 'lodash/keyBy'
import RailsError from '../../util/RailsError'

@observer
class UserDetails extends Component {
  state = {
    user: null,
    errors: null,
    name: '',
    email: '',
    password: '',
    admin: false,
    agent_office_ids: []
  }

  editUser = event => {
    event.preventDefault()

    const { users } = this.props
    const { user, name, email, password, admin, agent_office_ids } = this.state

    users.update({ ...user, name, email, password, admin, agent_office_ids }).then(
      () => this.props.router.push('/users'),
      ({ response }) => this.setState({ errors: response.data && response.data.errors })
    ).then(() => {
      users.load(user.id)
    })
  }

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  handleAdmin = ({ target }) => this.setState({ admin: target.checked })

  handleMlsChange = ({ target }) => {
    const { agent_office_ids } = { ...this.state }
    const [mls_id, field] = target.name.split(':')
    agent_office_ids.find(item => item.mls_id === mls_id)[field] = target.value
    this.setState({ agent_office_ids })
  }

  updateUser = (users, user_id) => {
    const user = users.findById(user_id)

    if (user) {
      new Connection('teams').load(user.team_id).then(resp => {
        const agent_offices = keyBy(user.mls_users, mls_user => mls_user.mls_id)
        const { mls } = resp.data
        const agent_office_ids = mls.map(mls => ({
          mls_id: mls.mls_id,
          agent_id: agent_offices[mls.mls_id] ? agent_offices[mls.mls_id].agent_id : '',
          office_id: agent_offices[mls.mls_id] ? agent_offices[mls.mls_id].office_id : '',
        }))
        this.setState({ agent_office_ids })
      })
    }

    this.setState({ user })
    if (user) this.setState({ ...pick(user, ['name', 'email', 'admin']), agent_office_ids:[] })
  }

  componentWillReceiveProps({ users, params: { user_id } }) {
    this.updateUser(users, user_id)
  }

  componentWillMount() {
    const { users, params: { user_id } } = this.props
    this.updateUser(users, user_id)
  }

  render() {
    const { user, errors, name, email, password, admin, agent_office_ids } = this.state

    if (!user) return null

    return (
      <form onSubmit={this.editUser} ref={form => this.form = form}>
        <Link to="/users" className="breadcrumb">&laquo; Back to Add A User</Link>
        <div className="panel padded">
          <h2 className="title">Edit User</h2>

          {errors && <RailsError errors={errors} />}

          <div className="form-section">
            <label htmlFor="name">Name</label>
            <input id="name" name="name" value={name} onChange={this.handleChange} required />
          </div>

          <div className="form-section">
            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" name="email" value={email} onChange={this.handleChange} required />
          </div>

          <div className="form-section">
            <label htmlFor="admin">
              <input type="checkbox" id="admin" name="admin" checked={admin} onChange={this.handleAdmin} />
              Admin
            </label>
          </div>

          <div className="form-section">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" value={password} onChange={this.handleChange} autoComplete="new-password" />
            <p className="muted">Must be at least 6 characters</p>
          </div>

          <div className="form-section">
            <h3 className="title">MLS Agent Info</h3>
            {agent_office_ids.map(({mls_id, agent_id, office_id}) => (
              <div key={mls_id} className="agent-office-group">
                <strong>{mls_id}</strong>
                <label>Agent ID</label>
                <input name={`${mls_id}:agent_id`} value={agent_id} onChange={this.handleMlsChange} />
                <label>Office ID</label>
                <input name={`${mls_id}:office_id`} value={office_id} onChange={this.handleMlsChange} />
              </div>
            ))}
          </div>
        </div>
        <button type="submit" className="big shadowed">Save User</button>
      </form>
    )
  }
}

export default UserDetails



// WEBPACK FOOTER //
// client/components/sections/users/Details.js